import MessageDefinition from '../messages/message-definitions.json';

function getSpecificMessageParams(messageCode, messageData, generalMessageParams) {
  const propName = `$${messageCode}`;
  const specificMessageParamsValue = generalMessageParams[propName];
  const specificMessageParamsType = typeof specificMessageParamsValue;
  if (specificMessageParamsType === 'object') {
    return specificMessageParamsValue;
  }

  if (specificMessageParamsType === 'function') {
    return specificMessageParamsValue(messageData);
  }

  return null;
}

function buildMessageParams(messageCode, messageData, generalMessageParams) {
  const responseMessageParams = messageData.parameters || messageData.parametros || {};
  return {
    ...responseMessageParams,
    ...generalMessageParams,
    ...getSpecificMessageParams(messageCode, messageData, generalMessageParams),
  };
}

function getResponseMessage(messageData) {
  return messageData.message || messageData.mensagem || null;
}

export default function getMessage(messageData, generalMessageParams) {
  const responseCode = messageData.messageCode || messageData.codigoMensagem;
  const code = responseCode ? responseCode.toUpperCase() : null;
  const isMSIS = (code || '').includes('MSIS');
  const responseMessage = getResponseMessage(messageData);
  if (code && MessageDefinition[code]) {
    const messageParams = buildMessageParams(code, messageData, generalMessageParams || {});
    return {
      code,
      ...(responseMessage ? { message: responseMessage } : {}),
      messageParams,
      titleParams: messageParams,
      isMSIS,
    };
  }
  if (responseMessage) {
    return {
      message: responseMessage,
      type: 'danger',
      isMSIS,
    };
  }

  return null;
}
